import { Outlet, useLocation } from 'react-router-dom'
import Login from '../pages/Login'
import { AppSidebar } from '@/components/Sidebar/AppSidebar'
import { Separator } from '@/components/ui/separator'
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar'
import Breadcrumb from './Breadcrumb'

const MainLayout = () => {
  const location = useLocation()

  // 如果是登录页面，直接渲染登录组件
  if (location.pathname === '/login') {
    return <Login />
  }

  // 根据路由选择背景颜色
  const getBackgroundStyle = () => {
    if (location.pathname === '/') {
      return {
        background: 'linear-gradient(117deg, #EFEEFD 6.7%, #FFF 107.71%)',
      }
    } else if (
      location.pathname.includes('/chat') ||
      location.pathname.includes('/agents')
    ) {
      return {
        background: 'linear-gradient(179deg, #EFEEFD -20.94%, #FFF 87.93%)',
      }
    } else {
      return {
        background: '#f8f9fa',
      }
    }
  }

  return (
    <div className="flex h-screen">
      <SidebarProvider>
        <AppSidebar className="bg-sidebar" />
        <SidebarInset style={getBackgroundStyle()}>
          <header
            className={`flex min-h-[48px] shrink-0 items-center gap-2 border-b-[1px] border-[#EAE5F5] transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 ${
              location.pathname.includes('/agents') ? '' : 'bg-white'
            }`}
          >
            <div className="flex items-center gap-2 px-4">
              <SidebarTrigger className="-ml-1" />
              <Separator orientation="vertical" className="mr-2 h-4" />
              <Breadcrumb />
            </div>
          </header>
          {/* 主内容区 */}
          <div className="flex-1 overflow-auto">
            <div className="p-4 pt-4 h-full">
              <Outlet />
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  )
}

export default MainLayout
